import { cn } from '@heroui/react';
import { FC } from 'react';
import { NavLink } from 'react-router-dom';

import i18n from '~/common/helpers/i18n';

interface NavTabProps {
  to: string;
  name: string;
  isBeta?: boolean;
  'data-testid'?: string;
}

export const NavTab: FC<NavTabProps> = ({
  to,
  name,
  isBeta = false,
  'data-testid': dataTestId
}) => (
  <NavLink
    to={to}
    data-testid={dataTestId}
    className={({ isActive }) =>
      cn(
        'flex items-center justify-center gap-1.5 whitespace-nowrap border-b-[1.5px] border-solid px-4 py-2.5 !text-label-lg transition-colors',
        isActive
          ? 'border-on-surface text-on-surface'
          : 'border-transparent text-on-surface-variant hover:text-on-surface'
      )
    }
  >
    {name}
    {isBeta ? (
      <span className='rounded-full bg-positive-container px-2 text-label-md text-on-positive-container'>
        {i18n.t('label.beta')}
      </span>
    ) : null}
  </NavLink>
);
